var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',[_c('div',{staticClass:"container"},[_c('h4',[_vm._v("Are you sure you want to logout?")]),_vm._v(" "),_c('div',{staticClass:"container__buttons"},[_c('button',{staticClass:"button__logout",on:{"click":_vm.logout}},[_vm._v("Logout")]),_vm._v(" "),_c('button',{staticClass:"button__cancel",on:{"click":_vm.cancel}},[_vm._v("Cancel")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4f6e194","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/Logout.vue
// module id = KLkz
// module chunks = 0